import React from 'react';
import { Box, Drawer, Stack } from '@metarouter-private/mr-mui';
import { useTestPipelineDrawerContext } from 'app/pipeline-details/StatusItem/TestPipelineDrawerContextProvider';
import TestPipelineDrawerHeader from './TestPipelineDrawerHeader';
import TestPipelineDrawerTabsSection from './TestPipelineDrawerTabsSection';

export default function TestPipelineDrawer() {
  const {
    drawer: { open, onClose },
  } = useTestPipelineDrawerContext();

  return (
    <Drawer onClose={onClose} open={open} anchor="right" width="70%" data-test-id="test-pipeline-drawer">
      <Box p={2}>
        <Stack>
          <TestPipelineDrawerHeader />
          <TestPipelineDrawerTabsSection />
        </Stack>
      </Box>
    </Drawer>
  );
}
